import { createContext } from "react";
import Music from "../components/Music";

const MusicContext = createContext();


export { MusicContext, Music };
